import { markListingOwnerIntent } from 'api/utils/pendingCreateAdFlow'
import CreateAdPublishSuccess from 'components/createAd/CreateAdPublishSuccess'
import { usePermissions } from 'pages/authenticated/PermissionsContext'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useSearchParams } from 'react-router-dom'

type PublishedState = {
  listingId?: string
  mode?: 'created' | 'updated'
}

const CreateAdPublishedPage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const { refresh } = usePermissions()
  const state = location.state as PublishedState | null
  const listingIdFromQuery = (searchParams.get('listingId') || '').trim()
  const listingIdFromState =
    typeof state?.listingId === 'string' ? state.listingId.trim() : ''
  const listingId = listingIdFromQuery || listingIdFromState
  const mode =
    searchParams.get('mode') === 'updated' || state?.mode === 'updated'
      ? 'updated'
      : 'created'

  // Sync header role to owner after publish. Keep intent until email is verified
  // (PermissionsContext clears it) so the menu does not flash Locataire.
  useEffect(() => {
    if (!listingId) return
    markListingOwnerIntent()
    void refresh({ intent: 'list_property' })
  }, [listingId, refresh])

  if (!listingId) {
    return (
      <div className="mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center px-4 py-16 text-center">
        <h1 className="text-xl font-bold text-imovSecondary">
          {t('createAd.ownerAuth.missingResultTitle')}
        </h1>
        <p className="mt-2 text-sm text-gray-500">
          {t('createAd.ownerAuth.missingResultBody')}
        </p>
        <Link
          to="/create-ad"
          state={{ newListing: true }}
          className="mt-6 inline-flex min-h-[48px] items-center justify-center rounded-xl bg-imovPrimary px-5 text-sm font-semibold text-white transition hover:bg-imovPrimaryDark"
        >
          {t('createAd.ownerAuth.backToForm')}
        </Link>
      </div>
    )
  }

  return <CreateAdPublishSuccess listingId={listingId} mode={mode} />
}

export default CreateAdPublishedPage
